<template>
  <input type="text" readonly placeholder="Types" :value="typeString" :class="!typeString || typeString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    export default {
      name: "TypesBadgeList",
      props: {
        types: [Array, String],
      },
      computed: {
        typeString() {
          if (!this.types || this.types.length === 0) {
            return '';
          }

          var typeName = this.types.map(x =>  x.text);
          return typeName.join(', ');
        }
      },
        methods: {
        onClick(event) { this.$emit("click", event); }
      }
    }
</script>

<style scoped>
    .type-badge-container {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

    .type-badge-container:hover {
        border-bottom: 1px solid #18B9E7;
        cursor: pointer;
    }

    .type-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

    .type-badge.hidden {
        background: #d2d2d2;
    }

    .type-badge .name {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0 1em;
    }

    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }

    input [type=text]:focus {
        background: transparent;
    }
</style>
